import { ArrowUpRight } from "lucide-react";
import { services } from "../../mock";

const ServicesSection = () => {
  return (
    <section className="services" id="services">
      <div className="wrap">
        <div className="section-head reveal">
          <div>
            <div className="kicker">04 — Services</div>
            <h2>
              From idea
              <br />
              <span className="accent">to reality.</span>
            </h2>
          </div>
          <p>
            From the first sketch to the final permit set — thoughtful design and disciplined coordination through every stage.
          </p>
        </div>
        <div className="service-grid reveal">
          {services.map((s) => (
            <article className="service" key={s.num}>
              <span className="service-num">{s.num}</span>
              <div className="service-body">
                <h3>{s.title}</h3>
                <p>{s.copy}</p>
              </div>
              <span className="service-arrow">
                <ArrowUpRight size={22} strokeWidth={1.25} />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
